import React from 'react';
import ReactDOM from 'react-dom/client';
import { RangePage } from './RangePage';
import { SafeBoundary } from '@/components/SafeBoundary';
import { IdentityProvider } from '@/auth/useIdentity';
import { initMonitoring } from '@/lib/monitoring';

initMonitoring('range');

/**
 * IdentityProvider wraps the page so SignInCTA + useCloudSync render
 * correctly. The provider talks to the parent storefront via postMessage
 * (identityBridge); without a theme-side bridge it gracefully degrades to
 * anonymous after a 500ms timeout. Anonymous mode is fully functional —
 * sign-in is a value-add for cross-device sync, not a gate.
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeBoundary section="Range Log">
      <IdentityProvider>
        <RangePage />
      </IdentityProvider>
    </SafeBoundary>
  </React.StrictMode>
);
